import { createSelector } from '@ngrx/store';
import { TMachineMaintenanceState } from '../reducers';
import { TNeedleManagementState } from './needle-management.models';

export const getNeedleManagementState = (state: TMachineMaintenanceState) => state.needleManagementInfo;

export const getNeedleListInfo = createSelector(
  getNeedleManagementState,
  (state: TNeedleManagementState) => state.needleListingInfo,
);

export const getNeedleListPagination = createSelector(
  getNeedleManagementState,
  (state: TNeedleManagementState) => state.needleListingPagination,
);

export const getNeedleListDropdownInfo = createSelector(
  getNeedleManagementState,
  (state: TNeedleManagementState) => state.needleListDropdownInfo,
);

export const getNeedleRequestPagination = createSelector(
  getNeedleManagementState,
  (state: TNeedleManagementState) => state.needleRequestPagination,
);

export const getNeedleRequests = createSelector(
  getNeedleManagementState,
  (state: TNeedleManagementState) => state.needleRequests,
);

export const getLocalNeedleRequestPagination = createSelector(
  getNeedleManagementState,
  (state: TNeedleManagementState) => state.localNeedleRequestPagination,
);

export const getLocalStoreNeedleRequests = createSelector(
  getNeedleManagementState,
  (state: TNeedleManagementState) => state.localStoreNeedleRequests,
);
